
import axios from 'axios';
import QS from 'qs';
import {Message } from 'element-ui'
// import store from './store'
axios.defaults.timeout = 100000;
axios.defaults.baseURL ='';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

//http request 拦截器
axios.interceptors.request.use(
    config => {
      // if (localStorage.getItem('xctoken')) {
      //   config.headers.token = localStorage.getItem('xctoken');
      // }
      
      return config;
    },
    error => {
      return Promise.reject(err);
    }
  );
  
  
  //http response 拦截器
  axios.interceptors.response.use(
    response => {
      if(response.data.code == -2 || response.data.code == -3){
        Message({
          message: '您的登录状态已失效',
          type: 'warning'
        });
        setTimeout(()=>{
          window.location.href = '/'
        },2000)
        
      }else if(response.data.code == -1){
        Message({
          message: '您没有权限进行此操作',
          type: 'warning'
        });
      }else if(response.data.code == -4){
        Message({
          message: '您未支付服务费',
          type: 'warning'
        });
        setTimeout(()=>{
          window.location.href = '#/renew'
        },2000)
      }else if(response.data.code == 10000){
        
      }else{
        Message({
          message: response.data.msg,
          type: 'warning'
        });
      }

      // console.log('拦截器===========',response)
      return response;
      
    },
    error => {
      return Promise.reject(error)
    }
  )
  

  //post请求
  export function post(url,data){
    return new Promise((resolve,reject) => {
      console.log('url=========',url)
      console.log('params=========',data)
      data.token = localStorage.getItem('xctoken')
      // data.token = 213465
      data.admin_user_id = localStorage.getItem('uid')
      data.admin_username = localStorage.getItem('username')
      axios.post(url,QS.stringify(data))
           .then(response => {
             if(response.data.code == 10000){
              resolve(response.data);
             }else{
              reject(response.data)
             }
            
           },err => {
             reject(err)
           })
    })
  }




// WEBPACK FOOTER //
// ./src/config/ajax.js